<template>
  <div>
    <ul class="bt">
      <li style="line-height: 60px;">年龄(岁)</li>
      <li style="line-height: 60px;">正常远视储备均值</li>
      <li>
        <p style="padding: 5px 0;">度数:高度近视风险</p>
        <div>
          <p>男孩</p>
          <p>女孩</p>
        </div>
      </li>
    </ul>
    <ul class="nr">
      <li>3</li>
      <li>2.00</li>
      <li>0.37</li>
      <li>0.37</li>
    </ul>
    <ul class="nr">
      <li>4</li>
      <li>1.75</li>
      <li>0.12</li>
      <li>0.12</li>
    </ul>
    <ul class="nr">
      <li>5</li>
      <li>1.38</li>
      <li>-0.25</li>
      <li>-0.25</li>
    </ul>
    <ul class="nr">
      <li>6</li>
      <li>1.38</li>
      <li>-0.90</li>
      <li>-1.20</li>
    </ul>
    <ul class="nr">
      <li>7</li>
      <li>1.38</li>
      <li>-1.54</li>
      <li>-2.06</li>
    </ul>
    <ul class="nr">
      <li>8</li>
      <li>1.25</li>
      <li>-2.17</li>
      <li>-2.83</li>
    </ul>
    <ul class="nr">
      <li>9</li>
      <li>0.88</li>
      <li>-2.78</li>
      <li>-3.52</li>
    </ul>
    <ul class="nr">
      <li>10</li>
      <li>0.75</li>
      <li>-3.38</li>
      <li>-4.12</li>
    </ul>
    <ul class="nr">
      <li>11</li>
      <li>0.63</li>
      <li>-3.96</li>
      <li>-4.63</li>
    </ul>
    <ul class="nr">
      <li>12</li>
      <li>0.50</li>
      <li>-4.53</li>
      <li>-5.05</li>
    </ul>
    <ul class="nr">
      <li>13</li>
      <li>0.50</li>
      <li>-5.08</li>
      <li>-5.38</li>
    </ul>
    <ul class="nr">
      <li>14</li>
      <li>0.38</li>
      <li>-5.63</li>
      <li>-5.63</li>
    </ul>
    <ul class="nr">
      <li>15</li>
      <li>0.31</li>
      <li>-6.15</li>
      <li>-5.78</li>
    </ul>
    <ul class="nr">
      <li>16</li>
      <li></li>
      <li>-6.00</li>
      <li>-6.00</li>
    </ul>
    <ul class="nr">
      <li>17</li>
      <li></li>
      <li>-6.00</li>
      <li>-6.00</li>
    </ul>
    <ul class="nr">
      <li>18</li>
      <li></li>
      <li>-6.00</li>
      <li>-6.00</li>
    </ul>

  </div>
</template>

<script>
export default {
  name: "sgzd"
}
</script>

<style scoped lang="scss">
.bt {
  background: rgb(12,24,64);
  color: #FFFFFF;
  display: flex;
  border: 1px solid rgb(3, 85, 173);
  li {
    border-right: 1px solid rgb(3, 85, 173);
  }
  li:nth-child(1) {width: 120px;}
  li:nth-child(2) {width: 150px;}
  li:nth-child(3) {
    width: 290px;
    div {
        display: flex;
        p {width: 145px;padding: 5px 0;}
        p:nth-child(1) {background: #588ef3}
        p:nth-child(2) {background: rgb(143, 89, 20)}
      }
  }
}
.nr {
  display: flex;
  border: 1px solid rgb(3, 85, 173);
  li {
    border-right: 1px solid rgb(3, 85, 173);
    width: 145px;
    padding: 5px 0;
  }
  li:nth-child(1) {width: 120px;}
  li:nth-child(2) {width: 147px;}
  li:nth-child(3) {background: #c6ccf8;}
  li:nth-child(4) {background: #fae7c5;}
}
</style>
